import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const NCRRedirect = () => {
  const { type, id } = useParams();

  // Redirect to the NCR form with the new ID
  if (type === 'ncr') {
    setTimeout(() => (window.location.href = `/ncr/${id}`), 2000);
  } else if (type === 'return') {
    setTimeout(() => (window.location.href = `/return/${id}`), 2000);
  }
};

export { NCRRedirect };
